import { LockdownState, LockdownConfiguration, LockdownConfigurationByDesignation, StaleConfigurationData, UpdateLockdownDetailsPayload } from "./types";
import { MutationTree } from "vuex";
import { getDefaultState } from "./state";

export const mutations: MutationTree<LockdownState> = {
    setConfigurationSelected(_, config: LockdownConfigurationByDesignation) {
        config.selected = true;
    },
    setConfigurationDeselected(_, config: LockdownConfigurationByDesignation) {
        config.selected = false;
    },
    setAllConfigurationsSelected(state) {
        state.lockdownConfigurations.forEach((config: LockdownConfigurationByDesignation) => {
            config.selected = true
        });
    },
    setAllConfigurationsDeselected(state) {
        state.lockdownConfigurations.forEach((config: LockdownConfigurationByDesignation) => {
            config.selected = false
        });
    },
    setLockdownModalVisible(state, flag: boolean) {
        state.lockdownModalVisible = flag;
    },
    setLockdownConfiguration(state, configuration: LockdownConfiguration) {
        state.lockdownConfiguration = configuration;
    },
    setLockdownConfigurations(state, configurations: LockdownConfigurationByDesignation[]) {
        state.lockdownConfigurations = configurations;
    },
    setStaleData(state, staleData: StaleConfigurationData[]) {
        state.staleData = staleData;
    },
    setStaleDataModalVisible(state, visibleFlag: boolean) {
        state.staleDataModalVisible = visibleFlag;
    },
    setUpdateReasonOnLockdownConfiguration(state, reason: string) {
        state.lockdownConfiguration.updateReason = reason;
    },
    setLockdownConfigurationPayload(state, payload: UpdateLockdownDetailsPayload) {
        state.lockdownConfigurationPayload = payload;
    },
    setSelectedClearanceFilterLevel(state, clearanceLevel: number) {
        state.selectedClearanceLevel = clearanceLevel;
    },
	resetState(state) {
		Object.assign(state, getDefaultState());
	}
}